import { render, staticRenderFns } from "./view-card.vue?vue&type=template&id=6fe5b7c2"
import script from "./view-card.vue?vue&type=script&lang=js"
export * from "./view-card.vue?vue&type=script&lang=js"
import style0 from "./view-card.vue?vue&type=style&index=0&id=6fe5b7c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports